import { HexagonIcon } from '@phosphor-icons/react';

import classNames from '@/utils/classnames';

/** The agent's hexagon tile (spec §6), breathing with the Pulse (§9) while `pulsing`. */
export function AgentMark({ pulsing }: { pulsing: boolean }) {
  return (
    <div
      className={classNames(
        'flex size-6.5 shrink-0 items-center justify-center rounded-lg border border-brand-border bg-brand-tint',
        pulsing && 'zooid-pulse',
      )}
    >
      <HexagonIcon size={14} weight="fill" className="text-brand-text" />
    </div>
  );
}
